const CSRF_COOKIE_NAME = "csrf_token";

export const getCsrfTokenFromCookie = (): string | null => {
  if (typeof document === "undefined") return null;
  const prefix = `${CSRF_COOKIE_NAME}=`;
  const cookies = document.cookie ? document.cookie.split(";") : [];
  for (const part of cookies) {
    const trimmed = part.trim();
    if (trimmed.startsWith(prefix)) {
      return decodeURIComponent(trimmed.slice(prefix.length));
    }
  }
  return null;
};

export const getCsrfHeaders = (): Record<string, string> => {
  const token = getCsrfTokenFromCookie();
  return token ? { "X-CSRF-Token": token } : {};
};
